import styled from 'react-emotion'
import { rowHeight, border } from '../../style'
import { StyledFormElement as FormElement } from './FormElement'
import Button from 'common/components/Button'
import { LabelSet } from 'common/components/Label/Label';

export const Toolbar = styled('div')(({ top, bottom, borderless, large }) => ({
  label: 'Toolbar',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  margin: 0,
  height: large ? rowHeight.large : rowHeight.default,
  minHeight: large ? rowHeight.large : rowHeight.default, // also needed to stop flexbox squishing it
  maxWidth: '100vw', // prevent overflow on small screen
  background: 'none',

  borderBottom: top && border,
  borderTop: bottom && border,

  [`& > ${FormElement}, & > ${
    Toolbar.Spacer
  }`]: !borderless && {
    '&:not(:last-child)': {
      // 1px line between items
      borderRight: border
    }
  },

  [`& > ${FormElement}, & > .react-shortcuts > ${FormElement}`]: {
    display: 'flex',
    flexDirection: 'row',
    border: 'none',
    overflow: 'hidden',
    borderRadius: 0
  }
}))

Toolbar.Spacer = styled('span')({
  flex: 1,
  padding: 0,
  border: 0,
  margin: '0 -1px' // make borders of things on my left/right overlap when I colapse to 0
})

export const Toolbar2 = styled('div')(({ top, bottom, large }) => ({
  label: 'Toolbar2',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  margin: 0,
  height: large ? rowHeight.large : rowHeight.default,
  minHeight: large ? rowHeight.large : rowHeight.default, // also needed to stop flexbox squishing it
  maxWidth: '100vw', // prevent overflow on small screen
  background: '#fff',

  borderBottom: top && border,
  borderTop: bottom && border,

  [`& > ${Button}, & > ${LabelSet}`]: {
    marginRight: 5,
    '&:first-child': { marginLeft: 5 }
  },

  [`& > ${FormElement}`]: {
    // display: 'flex',
    // flexDirection: 'row',
    border: 'none'
    // overflow: 'hidden',
    // borderRadius: 0
  }
}))

Toolbar2.Spacer = styled('span')({
  label: 'Spacer',
  flex: 1
})

export default Toolbar
